module.exports = __webpack_public_path__ + "static/media/version_vault.b0dd7be7.svg";